import React from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { OrderList } from '@/pages/orders/list';
import { adaptOrdersHandoff } from '@/services/orders/orderService';
import { fromOrdersHandoffRouteState } from '@/providers/stateAdapters';

export const OrdersModule: React.FC = () => {
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const routeState = fromOrdersHandoffRouteState(location.state);
		const handoff = adaptOrdersHandoff(routeState);

		if (!handoff) {
			return;
		}

		if (handoff.previousUrl) {
			localStorage.setItem('previousUrl', handoff.previousUrl);
		}

		if (handoff.action === 'open-details' && handoff.orderId) {
			navigate(`/orders/${handoff.orderId}`, { replace: true });
			return;
		}

		if (handoff.action === 'create-new') {
			navigate('/orders/new', { replace: true });
		}
	}, [location.state, navigate]);

	return <OrderList />;
};

export { OrderList };
